import React, { useState } from 'react';
import * as R from 'ramda';
import { CustomBase } from './customBase';
import { Placement } from './placement';
import { Assurance } from './assurance';
import { Credit } from './credit';
import { CompteCurrent } from './compteCurrent';
import { BankAccountType } from '../../../../../constants/models/servicePayloads/bankAccountType';
import Bank from '../../../../../constants/models/servicePayloads/bank';
import { ConnectionTypes, convertConnectionTypesToServiceType } from '../../../../../constants/utils/connectionTypes';
import { useDispatch, useSelector } from 'react-redux';
import ServiceData from '../../../../../constants/models/serviceData';
import { addServiceData, updateServiceData, deleteServiceData } from '../../../../../actions/services-api';
import * as Loadings from '../../../../../constants/loadings/service';

export const BankDetails = ({ isMain, branch, index, removeBranch, setShowCustomBox, formRef, setCollapsed }) => {
    const user = useSelector(state => state.user);
    const services = useSelector(state => state.services);
    const [selectedNonOption, setSelectedNonOption] = useState({
        current: false,
        placements: false,
        assurance: false,
        credit: false
    });
    const dispatch = useDispatch();
    const currentAccountBankAccountTypes = [BankAccountType.CompteCurrent.accountType];
    const placementsBankAccountTypes = [BankAccountType.LivretA.accountType, BankAccountType.Ldds.accountType, BankAccountType.Lep.accountType, BankAccountType.LivretJeune.accountType,
    BankAccountType.Cel.accountType, BankAccountType.Pel.accountType, BankAccountType.Perp.accountType, BankAccountType.LivretEpargneBancaire.accountType,
    BankAccountType.Cat.accountType, BankAccountType.CoffreFortBancaire.accountType, BankAccountType.Scpi.accountType, BankAccountType.Pea.accountType,
    BankAccountType.CompteTitre.accountType, BankAccountType.Opcvm.accountType];
    const assuranceBankAccountTypes = [BankAccountType.AssuranceDeces.accountType, BankAccountType.AssuranceObseque.accountType, BankAccountType.AssuranceVie.accountType];
    const creditsBankAccountTypes = [BankAccountType.CreditVoiture.accountType, BankAccountType.CreditImmobilier.accountType, BankAccountType.CreditTravaux.accountType, BankAccountType.CreditConsummation.accountType, BankAccountType.CreditAutre.accountType];

    let hasCompteCurrentAccounts = false;
    let hasPlacementAccounts = false;
    let hasAssuranceAccounts = false;
    let hasCreditAccounts = false;
    if (!R.isNil(branch) && !R.isNil(branch.payload) && !R.isNil(branch.payload.accounts)) {
        hasCompteCurrentAccounts = branch.payload.accounts.findIndex(a => currentAccountBankAccountTypes.indexOf(a.accountType) > -1) > -1;
        hasPlacementAccounts = branch.payload.accounts.findIndex(a => placementsBankAccountTypes.indexOf(a.accountType) > -1) > -1;
        hasAssuranceAccounts = branch.payload.accounts.findIndex(a => assuranceBankAccountTypes.indexOf(a.accountType) > -1) > -1;
        hasCreditAccounts = branch.payload.accounts.findIndex(a => creditsBankAccountTypes.indexOf(a.accountType) > -1) > -1;
    }

    let initState = {
        serviceType: ConnectionTypes.Bank,
        serviceId: branch.serviceId,
        payload: new Bank()
    };
    if (!R.isNil(branch.id)) {
        initState = branch;
    }

    const [globalPayload, setGlobalPayload] = useState(initState);

    return (
        <div>
            <CustomBase index={index} setSelectedNonOption={(op) => { setSelectedNonOption({ ...selectedNonOption, current: op }) }} branch={branch} expanded={hasCompteCurrentAccounts} title="Compte courant" customeComponent={<CompteCurrent branch={branch} isMain={isMain} globalPayload={globalPayload} setGlobalPayload={setGlobalPayload} />} />
            <hr className="mb-gutter" />

            <CustomBase index={index} setSelectedNonOption={(op) => { setSelectedNonOption({ ...selectedNonOption, placements: op }) }} branch={branch} expanded={hasPlacementAccounts} title="Vos placements bancaires" customeComponent={<Placement branch={branch} isMain={isMain} globalPayload={globalPayload} setGlobalPayload={setGlobalPayload} />} />

            <hr className="mb-gutter" />

            <CustomBase index={index} setSelectedNonOption={(op) => { setSelectedNonOption({ ...selectedNonOption, assurance: op }) }} branch={branch} expanded={hasAssuranceAccounts} title="Vos assurances bancaires" customeComponent={<Assurance branch={branch} isMain={isMain} globalPayload={globalPayload} setGlobalPayload={setGlobalPayload} />} />
            <hr className="mb-gutter" />

            <CustomBase index={index} setSelectedNonOption={(op) => { setSelectedNonOption({ ...selectedNonOption, credit: op }) }} branch={branch} expanded={hasCreditAccounts} title="Vos crédits bancaires" customeComponent={<Credit branch={branch} isMain={isMain} globalPayload={globalPayload} setGlobalPayload={setGlobalPayload} />} />
            <hr className="my-0" />
            <div className="card-footer text-right px-0">
                <button className={"btn btn-sm btn-alert-info border-none loading-btn" + (services.isLoading.includes(Loadings.ADD_NEW_SERVICE+branch.id) || services.isLoading.includes(Loadings.UPDATING_SERVICE_DATA+branch.id) ? ' show': '')}
                disabled={R.isNil(globalPayload.payload) || (!R.isNil(globalPayload.payload.accounts) && globalPayload.payload.accounts.filter(a => a.number !== '').length === 0) || (services.isLoading.includes(Loadings.ADD_NEW_SERVICE+branch.id) || services.isLoading.includes(Loadings.UPDATING_SERVICE_DATA+branch.id))} 
                onClick={(e) => {
                   
                   e.preventDefault();
                    if (formRef.current.checkValidity()) {
                        let serviceData = new ServiceData({ userId: user.user.id, serviceType: convertConnectionTypesToServiceType(ConnectionTypes.bank), serviceId: branch.id, customServiceDetails: branch.customServiceDetails, payload: globalPayload.payload });
                        if (R.isNil(serviceData.serviceId) || serviceData.serviceId === ''){
                            serviceData.serviceId = branch.id !== '' ? branch.id :  !R.isNil(branch.customServiceDetails) ? 'custom': branch.serviceId;
                        }
                        if (selectedNonOption.current === true) {
                            serviceData.payload.accounts = serviceData.payload.accounts.filter(a => currentAccountBankAccountTypes.indexOf(a.accountType) === -1);
                        }
                        if (selectedNonOption.placements === true) {
                            serviceData.payload.accounts = serviceData.payload.accounts.filter(a => placementsBankAccountTypes.indexOf(a.accountType) === -1);
                        }
                        if (selectedNonOption.assurance === true) {
                            serviceData.payload.accounts = serviceData.payload.accounts.filter(a => assuranceBankAccountTypes.indexOf(a.accountType) === -1);
                        }
                        if (selectedNonOption.credit === true) {
                            serviceData.payload.accounts = serviceData.payload.accounts.filter(a => creditsBankAccountTypes.indexOf(a.accountType) === -1);
                        }

                        if (R.isNil(branch.serviceId)) {
                            dispatch(addServiceData(serviceData))
                            .then(() => setCollapsed(true));
                            if (!R.isNil(setShowCustomBox)) {
                                setShowCustomBox(false);
                            }
                        }
                        else {
                            serviceData.id = branch.id;
                            dispatch(updateServiceData(serviceData))
                            .then(() => setCollapsed(true));;
                        }
                    }
                    formRef.current.classList.add('was-validated');
                }}>
                    enregistrer
                                            <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                </button>
                <span className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none" id="basic-addon2" onClick={(e) => {
                    e.preventDefault();
                    if (R.isNil(branch.serviceId)) {
                        if (!R.isNil(setShowCustomBox)) {
                            setShowCustomBox(false);
                        }
                        if (!R.isNil(removeBranch)) {
                            removeBranch(branch.serviceId);
                        }
                    } else {
                        dispatch(deleteServiceData(branch.id, ConnectionTypes.bank));
                    }
                }}><i className="eva eva-trash-outline"></i></span>
            </div>
        </div>
    )
}